import styled from 'styled-components';

import {
  SkeletonCard as DefaultSkeletonCard,
  SkeletonButton as DefaultSkeletonButton,
} from '@xing-com/skeleton';
import { spaceL, spaceM, spaceXL } from '@xing-com/tokens';

export const SkeletonCard = styled(DefaultSkeletonCard)`
  height: 430px;
  min-width: 288px;
  max-width: 410px;
  display: flex;
  flex-direction: column;
`;

export const SkeletonProfileLink = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto ${spaceXL};
`;

export const SkeletonMainArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceM};
  margin-bottom: ${spaceXL};
`;

export const SkeletonDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  margin-bottom: ${spaceXL};
`;

export const SkeletonButton = styled(DefaultSkeletonButton)`
  max-width: 110px;
  margin: ${spaceL} auto 0;
`;
